import { render, staticRenderFns } from "./HonorsV2.vue?vue&type=template&id=59d1f5ba&scoped=true"
import script from "./HonorsV2.vue?vue&type=script&lang=js"
export * from "./HonorsV2.vue?vue&type=script&lang=js"
import style0 from "./HonorsV2.vue?vue&type=style&index=0&id=59d1f5ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d1f5ba",
  null
  
)

export default component.exports